import React from 'react';
import { Tag, Icon, Spin } from 'antd';
import cn from 'classnames';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import useDeleteInfoBind from '../../../../mutations/useDeleteInfoBind';
import { createInfoBindKey } from '../../../../queries/useInfoBinds';
import { selectedInfoSelector } from '../../../../store/selectors';
import styles from './Bind.module.scss';

const Bind = ({ className, content, item, small = false, ...props }) => {
  const info = useSelector(selectedInfoSelector);
  const queryClient = useQueryClient();
  const { deleteBind, deleteBindsAsync, loading } = useDeleteInfoBind();

  const deleteByIds = async (bindIds) => {
    const ids = Array.from(new Set(bindIds.filter(Boolean)));

    if (ids.length === 0) {
      return;
    }

    if (ids.length === 1) {
      deleteBind(ids[0]);
      return;
    }

    await deleteBindsAsync(ids);
  };

  const handleClose = async (e) => {
    e.preventDefault();

    if (!info?.id) {
      deleteBind(item.id);
      return;
    }

    const binds = queryClient.getQueryData(createInfoBindKey(info.id)) || [];

    if (item.address) {
      await deleteByIds([item.id]);
      return;
    }

    if (item.house) {
      const relatedRoomBindIds = binds
        .filter(
          (bind) =>
            bind.address?.houseId === item.house.id &&
            bind.serviceCompany?.id === item.serviceCompany?.id
        )
        .map((bind) => bind.id);

      await deleteByIds([item.id, ...relatedRoomBindIds]);
      return;
    }

    const companyId = item.serviceCompany?.id;

    if (companyId) {
      const relatedBindIds = binds
        .filter((bind) => bind.serviceCompany?.id === companyId)
        .map((bind) => bind.id);

      await deleteByIds([item.id, ...relatedBindIds]);
      return;
    }

    deleteBind(item.id);
  };

  return (
    <Spin
      spinning={loading}
      delay={200}
      indicator={<Icon type="loading" />}
    >
      <Tag
        {...props}
        className={cn(styles.root, className, {
          [styles.small]: small,
        })}
        closable
        onClose={handleClose}
      >
        {content}
      </Tag>
    </Spin>
  );
};

export default Bind;
